import React from "react";
import { generateSectionConfig } from "@carrier-ecat/ngecat-commonworkflowui";
import { RULES, TAGS } from "../../../constants/rules";
import { Select, Slider, Typography, ButtonGroup } from '@carrier-ecat/ngecat-tsreactcomponents';
import Tune from '@material-ui/icons/Tune';
import { messages } from "../../../../src/constants/intl";
import { Divider } from "@material-ui/core";
const selectionRequirements = generateSectionConfig(RULES, [TAGS.UI_SEL, TAGS.UI_SEL_REQ, TAGS.UI_SEL_REQ_REQS], {
    label: 'Selection Requirements',
    id: 'section-1',
    icon: () => React.createElement(Tune, null),
    components: [{
            size: 12,
            cells: [
                {
                    component: React.createElement(Typography, { align: "left" }, messages.UI_ElectricRequirement),
                    props: { visible: true }
                },
            ],
        },
        {
            size: 2,
            cells: [
                {
                    rule: { name: RULES.UI_SEL_REQ_REQS.BU_SFREQZ },
                    component: React.createElement(ButtonGroup, { name: '' }),
                },
            ]
        },
        {
            size: 3,
            cells: [{
                    rule: { name: RULES.UI_SEL_REQ_REQS.BU_SVOLTAGE },
                    component: React.createElement(Slider, { evenlySpaced: true, restrictToValues: true }),
                    props: { label: messages.BU_SVOLTAGE }
                }
            ]
        },
        {
            size: 12,
            spacing: 3,
            cells: [{
                    component: React.createElement(Divider, { orientation: "horizontal", style: { justifySelf: 'center' } }),
                    props: { visible: true },
                }],
        },
        {
            size: 12,
            cells: [
                {
                    component: React.createElement(Typography, { align: "left" }, messages.EQUIP_REQ),
                    props: { visible: true }
                },
            ],
        },
        {
            size: 12,
            cells: [
                {
                    component: React.createElement(Select, { label: messages.BU_NBPHE.defaultMessage }),
                    rule: { name: RULES.UI_SEL_REQ_REQS.BU_NBPHE },
                },
                {
                    component: React.createElement(Select, { label: messages.BU_SPRIMARYLOOPSTRAINER.defaultMessage }),
                    rule: { name: RULES.UI_SEL_REQ_REQS.BU_SPRIMARYLOOPSTRAINER },
                },
                {
                    component: React.createElement(Select, { label: messages.BU_SSECONDLOOPFILTER.defaultMessage }),
                    rule: { name: RULES.UI_SEL_REQ_REQS.BU_SSECONDLOOPFILTER },
                },
                {
                    component: React.createElement(Select, { label: messages.BU_SUNITSIZE.defaultMessage }),
                    rule: { name: RULES.UI_SEL_REQ_REQS.BU_SUNITSIZE },
                },
            ]
        },
    ]
});
export default selectionRequirements;
